var ProductCartComponent = Vue.component('product-cart', {
    props: [],
    data: function () {
        return {
            quantity: 1
        };
    },
    mounted: function() {
        var _self = this,
            input = this.$refs.input;

        if (input != undefined) {
            $(input).on("spinstop", function(event) {
                _self.quantity = event.target.value;
            });
        }
    },
    methods: {
        submit: function() {
            if (this.isDisabled) {
                return;
            }

            if (!this.quantity) {
                this.quantity = 1;
            }

            this.$store.dispatch('addCartItem', {
                product_id: this.$parent.product.id,
                product_variation_id: this.$parent.product.product_variation_id,
                module_data: this.$parent.moduleData,
                quantity: this.quantity
            });
        }
    },
    computed: {
        isDisabled: function() {
            if (this.$parent.product.has_variations && !this.$parent.product.product_variation_id) {
                return true;
            }

            return false;
        }
    }
});